import {Navigate} from "react-router-dom";
import {LinkAccountStore} from "./store";
import React from "react";
import {ExistingUserCard} from "../user/ExistingUserCard";

export const LinkAccount = () => {
  const email = LinkAccountStore.getEmail();
  if (!email) {
    return <Navigate to="/sign-up"/>;
  }
  return <ExistingUserCard email={email}/>;
};
